import React from 'react';
import cn from 'classnames';
import Avatar from '../UI/avatar';
import { ITripComment } from '../../Models/trips/trip-comment.model';
import { formatTimeAgo } from '../../helpers/time-ago';

interface CommentItemProps {
  comment: ITripComment;
  currentUserId: string;
  onDelete: (commentId: string) => void;
}

const CommentItem: React.FC<CommentItemProps> = ({
  comment,
  currentUserId,
  onDelete
}) => {
  const isOwnComment = comment.userId.toString() === currentUserId;
  const userInitial = comment.user?.username?.charAt(0).toUpperCase() || 'U';

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this comment?')) {
      onDelete(comment.id);
    }
  };

  return (
    <div
      className={cn('comment-item', {
        'comment-item--own': isOwnComment,
        'comment-item--other': !isOwnComment
      })}
    >
      {/* Left side: Avatar for other users */}
      {!isOwnComment && (
        <div
          className='comment-item__avatar'
          title={comment.user?.username || 'Unknown User'}
        >
          <Avatar
            src={comment.user?.photo}
            letter={userInitial}
            size='small'
            alt={comment.user?.username || 'User'}
          />
        </div>
      )}

      {/* Center: Comment content */}
      <div className='comment-item__content'>
        <div className='comment-item__header'>
          <span className='comment-item__timestamp'>
            {formatTimeAgo(comment.createdAt)}
          </span>
        </div>
        <div
          className={cn('comment-item__text', {
            'comment-item__text--own': isOwnComment,
            'comment-item__text--other': !isOwnComment
          })}
        >
          {comment.comment}
        </div>
        {isOwnComment && (
          <div className='comment-item__actions'>
            <button
              className='comment-item__delete-btn'
              onClick={handleDelete}
              aria-label='Delete comment'
            >
              Delete
            </button>
          </div>
        )}
      </div>

      {/* Right side: Avatar for own comments */}
      {isOwnComment && (
        <div
          className='comment-item__avatar'
          title={comment.user?.username || 'You'}
        >
          <Avatar
            src={comment.user?.photo}
            letter={userInitial}
            size='small'
            alt={comment.user?.username || 'You'}
          />
        </div>
      )}
    </div>
  );
};

export default CommentItem;
